export default __webpack_public_path__ + "static/media/provenance_record.048ed5e1.txt";